import { Link } from '@data/components/basic/Link/Link';
import { useMediaQuery } from 'react-responsive';
import { useMatch } from 'react-router-dom';
import { cn } from 'eds-common';
import ScholasticLogo from '@/assets/images/scholastic-logo.svg';
import ScholasticFlyingPagesLogo from '@/assets/images/scholastic-flying-pages-logo.svg';
import { StudentProfileMenu } from '@/components/ProfileMenu/StudentProfileMenu';
import { StudentNavigation } from '@/components/Navigation/StudentNavigation';
import { PlatformMenu } from '@/components/PlatformMenu/PlatformMenu';
import { KnockNotificationFeed } from '@/components/KnockNotificationFeed/KnockNotificationFeed';

const SKIP_NAV_CLASSES =
  'sr-only z-30 bg-brand-white text-lg text-blue-700 underline focus:not-sr-only focus:absolute focus:ml-10 focus:p-2';

export function StudentHeader() {
  const isMobile = useMediaQuery({ query: '(max-width: 639px)' });

  const Logo = isMobile ? ScholasticFlyingPagesLogo : ScholasticLogo;
  const isELAPath = useMatch('explore-ela/*');
  const isELAHome = useMatch('/explore-ela') !== null;

  if (isELAPath) {
    return (
      <header className="z-[1] shadow-header">
        <a className={SKIP_NAV_CLASSES} href="#main">
          Skip to main content
        </a>
        <div className="flex flex-col gap-8">
          <div className="z-10 -mb-8 flex h-6 justify-center bg-black">
            <Link to="/student" className="mt-3 bg-none">
              <Logo role="img" aria-label="scholastic logo" />
            </Link>
          </div>
          <div className="flex w-full justify-between bg-transparent pr-10 align-middle">
            <StudentNavigation />
            <div className="flex items-center">
              <KnockNotificationFeed darkMode={isELAHome} />
              <StudentProfileMenu />
            </div>
          </div>
        </div>
      </header>
    );
  }

  return (
    <header className="z-[1] border-t-8 border-brand-cliffordRed">
      <a className={SKIP_NAV_CLASSES} href="#main">
        Skip to main content
      </a>
      <div className="flex items-center justify-between px-4 pb-4 pt-6 tablet:px-10">
        <Link
          to="/student"
          className={cn(
            'inline-flex border border-brand-white bg-none focus-ring',
            isMobile ? 'rounded-md' : 'rounded-xs'
          )}
        >
          <Logo role="img" aria-label="scholastic logo" />
        </Link>
        <div className="flex items-center gap-3">
          <PlatformMenu triggerClassName="h-11 w-11 justify-center shadow-md" />
          <StudentProfileMenu />
        </div>
      </div>
    </header>
  );
}
